// extracted by mini-css-extract-plugin
module.exports = {"topComment":"gq8_X","topCommentLabel":"_3g2UF"};